<template>
  <div class="position-column">
    <navbar
      :title="$route.query.title"
      :bg-color="headerColor"
      ref="navbar"
      show-home
    />
    <div class="search" v-if="searchStatus">
      <div class="searchWrap" :style="{ backgroundColor: headerColor }">
        <button @click="onSearch" class="search-bar">
          <img alt src="../../assets/img/home/search-icon.png" />
          <span>搜索</span>
        </button>
      </div>
    </div>
    <div class="banner">
      <swiper :img-list="banners" />
    </div>
    <div
      class="tabs-wrapper"
      v-if="columnNavs.length"
      :style="{ backgroundColor: goodsListBg }"
    >
      <column-tabs
        :nav-titles="navTitle"
        :price-list="priceTitle"
        :nav-list="columnNavs"
        :offset-top="navbarHeight"
        :border-img="goodsBorderImg"
        nav-style="padding: 0 0.2rem"
        ref="columnTabs"
      ></column-tabs>
    </div>
    <!-- 回到顶部 -->
    <back-to-top :show-cart="false" />
  </div>
</template>

<script>
import api from '../../utils/api'
import Navbar from '../../components/NavBar'
import Swiper from '../../components/swiper'
import BackToTop from '../../components/BackToTop'
import ColumnTabs from '../../components/RecommendModule'
export default {
  name: 'positionColumn',
  components: {
    Navbar,
    Swiper,
    BackToTop,
    ColumnTabs
  },
  data () {
    return {
      textShow: false,
      pageTitle: '',
      searchStatus: 1,
      banners: [],
      columnNavs: [],
      navbarHeight: 0,
      objPageRule: {},
      priceTitle: [],
      navTitle: [],
      headerColor: '',
      goodsBorderImg: '',
      goodsListBg: ''
    }
  },
  created () {
    this.pageTitle = this.$route.query.title
    this.searchStatus = this.$route.query.searchStatus ? this.$route.query.searchStatus - 0 : 1
    this.pCode = this.$route.query.pCode
  },
  mounted () {
    this.navbarHeight = this.$refs.navbar.navbarHeight
    this.init()
  },
  activated () {
    this.pageTitle = this.$route.query.title
    this.searchStatus = this.$route.query.searchStatus ? this.$route.query.searchStatus - 0 : 1
    if (this.$route.query.pCode !== this.pCode) {
      this.pCode = this.$route.query.pCode
      this.banners = []
      this.columnNavs = []
      this.init()
    }
  },
  methods: {
    onSearch () {
      this.$router.push({ name: 'searchPages', query: { title: this.pageTitle } })
    },
    show () {
      this.visible = false
    },
    async init () {
      this.$toast.loading('正在加载...')
      this.getBanners()
      this.getHeaderColor()
      this.getGoodsBorderImg()
      this.getGoodsBg()

      const data = await this.getColumnNav()
      if (data) {
        let csid = []
        if (this.$route.query.title === '办公用品') {
          this.$refs.columnTabs.getContListAll(data[0] && data[0].configer.column, 1)
        } else {
          this.$refs.columnTabs.getContList(data[0] && [data[0].configer.column], 1)
        }
        for (let i in data) {
          csid.push(data[i].configer.column)
        }
        sessionStorage.setItem('csid', JSON.stringify(csid))
      }
      // if (this.pageTitle === '员工福利') {
      //   this.pageRule()
      // }
    },
    async getBanners () {
      const data = await api.getLocationCodingHandler(`${this.pCode}-banner`)
      if (data) {
        this.banners = data
      }
    },
    async getHeaderColor () {
      const data = await api.getLocationCodingHandler(`${this.pCode}-search`)
      if (data && data[0] && data[0].configer) {
        this.headerColor = data[0].configer.bgcolor
      }
    },
    async getGoodsBg () {
      const data = await api.getLocationCodingHandler(`${this.pCode}-background`)
      if (data && data[0] && data[0].configer) {
        this.goodsListBg = data[0].configer.bgcolor
      }
    },
    async getGoodsBorderImg () {
      const data = await api.getLocationCodingHandler(`${this.pCode}-frame`)
      if (data && data[0] && data[0].configer) {
        this.goodsBorderImg = data[0].configer.img
      }
    },
    async pageRule () {
      const data = await api.getJsonVersion('benefits')
      this.objPageRule = data['benefits-1']
    },
    async getColumnNav () {
      const data = await api.getLocationCodingHandler(this.pCode)
      this.$toast.clear()
      if (data) {
        this.columnNavs = data
      }
      return data
    },
    async getPrice () {
      const data = await api.getJsonVersion('worker').catch((err) => {
        this.$toast.clear()
        throw Error(err)
      })
      const p1 = data['worker-1']
      if (p1 && p1.data && p1.data.length > 1) {
        this.navTitle = p1.data
        this.getPriceNav(p1.data[1].position_code)
      }
    },
    async getPriceNav (str) {
      const data = await api.getLocationCodingHandler(str)
      this.$toast.clear()
      if (data) {
        this.priceTitle = data
      }
      return data
    }
  }
}
</script>
<style lang="less" scoped>
.search {
  width: 100%;
  height: 0.88rem;
  padding: 0.14rem 0.24rem;
  box-sizing: border-box;
  background-color: #343a4b;
  text-align: center;
  font-size: @fz24;
  color: @c80;
}
.searchWrap {
  position: fixed;
  left: 0;
  top: 0.88rem;
  z-index: 999;
  width: 100%;
  height: 0.88rem;
  padding: 0.14rem 0.24rem;
  box-sizing: border-box;
  background-color: #343a4b;
  text-align: center;
  font-size: @fz24;
  color: @c80;
  .search-bar {
    width: 100%;
    height: 0.6rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 30px;
    img {
      width: 0.3rem;
      object-fit: contain;
      padding-left: 0.2rem;
      padding-right: 0.1rem;
    }
  }
}
.banner {
  width: 100%;
  max-height: 3.15rem;
  overflow: hidden;
}
</style>
